import { createContext } from "react";
import { noop } from "@common/helpers/function";
import {
    RuleGroupType,
    TransactionRuleGroup,
} from "@common/types/transactionRule";

interface Context {
    updateRuleGroup(ruleGroup: TransactionRuleGroup | null): void;
    deleteRuleGroup(ruleGroup: TransactionRuleGroup | null): void;
    createRuleGroup(type: RuleGroupType): void;
    ruleGroupToUpdate: TransactionRuleGroup | null;
    ruleGroupToDelete: TransactionRuleGroup | null;
    isCreatingRuleGroup: RuleGroupType | null;
}

export const TransactionRuleManagementContext = createContext<Context>({
    updateRuleGroup: noop,
    deleteRuleGroup: noop,
    createRuleGroup: noop,
    ruleGroupToUpdate: null,
    ruleGroupToDelete: null,
    isCreatingRuleGroup: null,
});
